import React from 'react'
import { Flex } from 'rebass'
import { PLATFORM_ENUM } from 'services/api/constants'
import { SocialMediaAccount } from 'state/submissions'
import { PLATFORM_DISPLAY_NAME } from 'services/numbers'
import { theme } from 'theme'
import { useNewTranslation } from 'hooks/index'
import { RequirementState, FollowerState } from 'state/campaigns'
import Text from 'particles/Text'

interface SocialMediaFollowerTier {
    social_media_accounts: SocialMediaAccount[]
    followerRequirement: RequirementState
}

const SocialMediaFollowerTier: React.FC<SocialMediaFollowerTier> = ({ social_media_accounts, followerRequirement }) => {
    const [newT] = useNewTranslation()
    const platformKeys = Object.keys(PLATFORM_DISPLAY_NAME).filter((platformType: string) =>
        followerRequirement.properties.followers
            ? followerRequirement.properties.followers.find(
                  (follower: FollowerState) => follower.platform.toString() == platformType,
              )
            : false,
    )
    const followerRangeList = platformKeys.map((platformType: string) => {
        const socialMediaAccount = social_media_accounts.find(
            (socialMediaAccount: SocialMediaAccount) => socialMediaAccount.platform == Number(platformType),
        )
        const platformName = PLATFORM_DISPLAY_NAME[Number(platformType) as PLATFORM_ENUM]
        if (socialMediaAccount) {
            const followerDisplay = socialMediaAccount.follower_count?.toString()
            return followerDisplay ? `${followerDisplay} (${platformName})` : 'N/A (' + platformName + ')'
        } else {
            return 'N/A (' + platformName + ')'
        }
    })

    return (
        <Flex flexWrap="wrap">
            <Text scale="caption400" style={{ marginRight: theme.spacing.xxxxs, textAlign: 'left' }}>
                {newT('socialMedia.requirement.followers')}:
            </Text>
            {followerRangeList.map((followerRange: string, index: number) => {
                if (followerRange.includes('N/A')) {
                    return (
                        <>
                            <Text
                                key={index}
                                scale="caption400"
                                style={{ marginRight: theme.spacing.xxxxs, textAlign: 'left' }}
                            >
                                {followerRange}
                            </Text>
                            {index < followerRangeList.length - 1 ? (
                                <Text
                                    key={index}
                                    scale="caption400"
                                    style={{
                                        marginRight: theme.spacing.xxxxs,
                                        textAlign: 'left',
                                    }}
                                >
                                    ,
                                </Text>
                            ) : null}
                        </>
                    )
                } else {
                    return (
                        <>
                            <Text key={index} scale="caption400" style={{ textAlign: 'left' }}>
                                {followerRange}
                            </Text>
                            {index < followerRangeList.length - 1 ? (
                                <Text
                                    key={index}
                                    scale="caption400"
                                    style={{ marginRight: theme.spacing.xxxxs, textAlign: 'left' }}
                                >
                                    ,
                                </Text>
                            ) : null}
                        </>
                    )
                }
            })}
        </Flex>
    )
}
export default SocialMediaFollowerTier
